// src/pages/Signup.jsx
import React from 'react';
import Navbar from '../components/Navbar/Navbar';
import AuthLayout from '../components/Auth/AuthLayout';
import SignupForm from '../components/Auth/SignupForm';
import signupBg from './../assets/signup-bg.jpg';

function Signup() {
  return (
    <>
      <Navbar />
      <AuthLayout backgroundImage={signupBg}>
        <SignupForm />
      </AuthLayout>
    </>
  );
}

export default Signup;
